<template>
	<div class="single-page-wrap">
		<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
			<div v-if="historyList.length > 0">
				<div class="weui-form__control-area">
					<div class="weui-cells__group weui-cells__group_form">
						<div class="weui-cells weui-cells_checkbox">
							<label class="weui-cell weui-check__label"
								   :for="item.id" v-for="item of historyList">
								<div @click="openDetails(item)" class="weui-cell__bd">
									<p style="display: flex; justify-content: space-between">
										<span>{{item.createTime}}</span>
										<span style="font-size: 12px">已开票({{item.status}})</span>
									</p>
									<p style="display: flex; justify-content: space-between;align-items: center">
										<span style="font-size: 14px">{{item.parkName || '停车缴费'}}</span>
										<span style="font-size: 20px;font-weight: 400;color: #000000">{{item.amount}}元</span>
									</p>
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>

			<no-data v-else msg="暂无"></no-data>
		</cube-scroll>
	</div>
</template>

<script>
	import { getUserTicketHistory,getUserTicketDetails } from "../../../api/coupon/receiptHistory";
	import { mapGetters } from 'vuex'
    export default {
        name: "index",
		data () {
            return {
                historyList: [],
                scrollOptions: {
                    click: true,
                    bounce: false
                },
                goodsTypeOptions: {
                    1: "充值余额",
                    2: "出口缴费",
                    3: "场内支付",
                    4: "商家购买停车券",
                    5: "普通用户购买停车券"
                },
			}
		},
		computed: {
			...mapGetters(['userOpenid'])
		},
		created () {
            this.getUserTicketHistory()
		},
		methods: {
            getUserTicketHistory () {
                getUserTicketHistory({openid:localStorage.getItem('userOpenId')||this.userOpenid  }).then(res =>{
                    let historyList = res.data;
                    historyList.map(item =>{
                        if (this.goodsTypeOptions[item.goodsType]){
                            this.$set(item,'goodsTypeName',this.goodsTypeOptions[item.goodsType])
                        }
                        item.amount = parseFloat(item.amount).toFixed(2);
					});
                    this.historyList = historyList;
				})
			},
			openDetails(item){
				getUserTicketDetails(item.reId).then(res =>{
                        if (res.code == 200){
							var buyerName = item.buyerName;
							var email = item.email;
							var phone = item.phone;
							var amount = item.amount;
							var type = item.type;
							var typeName = item.type==1?'企业开票':'个人开票';
							this.$router.push({
								name: 'ticketDetails', 
								params: {
									ticketDetails: res.data,
									ticketInfo: item
								}
							})
                        } else {
							this.$createDialog({
								type: "alert",
								title: "提示",
								content: "获取信息失败",
								icon: "cubeic-alert"
							}).show();
                        }
				})
			}
		}
    }
</script>

<style scoped lang="stylus">
	.cube-scroll {
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 95%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 20px
		.no-data-wrap {
			padding-top 25%
			display flex
			justify-content center
			align-items center
			.weui-article{
				color $no-data-font-color
				h1{
					font-size $no-data-font-size
				}
			}
		}
		.weui-form__control-area{
			margin-top 0
		}
		.weui-cells:before{
			border-top none
		}
		.weui-cells__group_form .weui-cell{
			padding  16px
		}
	}
</style>
